export class Dten {
    constructor(socket, log) {
        this.socket = socket;
        this.power = false;
        this.validVideoInputs = {
            pc: '\x24',
            vga: '\x21',
            hdmi1: '\x23',
            hdmi2: '\x43',
            dp: '\x63',
        };
        this.videoInput = '\x23';
        this.asyncHandlers = [
            {
                name: 'inputSet',
                regExp: /\xFE\x60\x00([\s\S])\x00/,
                callback: (match) => {
                    this.videoInput = match[1];
                },
            },
            {
                name: 'inputGet',
                regExp: /\xFE\x60\x00\x00\x00/,
                callback: (match) => {
                    this.socket.send(`\xFE\x60\x00${this.videoInput}\x00`);
                },
            },
            {
                name: 'powerOn',
                regExp: /\x99\xA2\x01\x01\x27\xAA\xAA/,
                callback: (match) => {
                    this.power = true;
                },
            },
            {
                name: 'powerOff',
                regExp: /\x99\x01\x05\x01\xFA/,
                callback: (match) => {
                    this.power = false;
                },
            },
            {
                name: 'powerGet',
                regExp: /\x99\x01\x05\x00\xFA/,
                callback: (match) => {
                    this.socket.send(`\x99\x01\x00${this.power}\x00`);
                },
            },
            {
                name: 'invalid',
                regExp: /.+/,
                callback: (match) => {
                    this.socket.send('Error');
                },
            },
        ];
    }
    onConfigure(config) {
        var _a;
        let lowestCode = this.validVideoInputs.dp;
        const videoInputs = (_a = config.videoInputs) !== null && _a !== void 0 ? _a : {};
        for (const key of Object.keys(videoInputs)) {
            const code = this.validVideoInputs[videoInputs[key].code];
            if (this.videoInput === code)
                return;
            if (code.charCodeAt(0) < lowestCode.charCodeAt(0)) {
                lowestCode = code;
            }
        }
        this.videoInput = lowestCode;
    }
}
Dten.emulatorType = 'socketEmulator';
Dten.key = '-MOY0lfM8MXbwgItR7pc';
